export {default as array} from './array';
export {default as boolean} from './boolean';
export {default as date} from './date';
export {default as function} from './function';
export {default as number} from './number';
export {default as object} from './object';